
export function getColorMappingValue(settings, blockPropertyId) {

    if (settings.accountSettings === undefined) return undefined;

    const matchedProp = settings.accountSettings.blocksPropertiesMappings.find(bp => bp.blockPropertyId === blockPropertyId);
    return (matchedProp === undefined) ? undefined : matchedProp.propValue;
}
